import { isBrowser } from "utils/infrastructure/ssg-utils"

export function getLocationPath() {
    if (!isBrowser()) return
    return window.location.pathname + window.location.search
}
